import { render, staticRenderFns } from "./ClassVerified.vue?vue&type=template&id=1268cd61&"
import script from "./ClassVerified.vue?vue&type=script&lang=js&"
export * from "./ClassVerified.vue?vue&type=script&lang=js&"
import style0 from "./ClassVerified.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports